import ctl from "@netlify/classnames-template-literals";

export type SearchListboxVariant = "light" | "dark";

export const inputBar = (variant: SearchListboxVariant = "light") =>
  ctl(`
  flex
  flex-row
  ${variant === "dark" ? "bg-neutral-800 text-neutral-200" : "bg-neutral-100 text-neutral-900"}
  p-2
  pl-5
  flex
  items-center
  justify-between
  w-full
  rounded
  shadow-sm
  text-left
  cursor-pointer
  focus:outline-none
  focus:ring-1
  ${variant === "dark" ? "focus:ring-purple-500 focus:border-purple-500" : "focus:ring-blue-500 focus:border-blue-500"}
`);

export const optionsList = (variant: SearchListboxVariant = "light") =>
  ctl(`
  w-auto
  absolute
  z-10
  min-w-full
  ${variant === "dark" ? "bg-neutral-800 text-neutral-200 ring-neutral-700" : "bg-white text-neutral-900 ring-black ring-opacity-5"}
  max-h-56
  rounded
  overflow-y-auto
  text-base
  ring-1
  focus:outline-none
  sm:text-sm
`);

export const option = (variant: SearchListboxVariant = "light") =>
  ctl(`
  cursor-pointer
  select-none
  relative
  py-2
  pl-3
  pr-9
  ${variant === "dark" ? "hover:bg-neutral-700 text-neutral-200" : "hover:bg-purple-650 hover:text-white"}
`);
